import { Braces, Boxes, Zap, Layers, Plug, ArrowDown } from "lucide-react";
import { Reveal } from "@/lib/anim";

const SERVICES = ["Payments", "Wallets", "Ledger", "Accounts", "Transactions"];
const EXTERNALS = ["Banks", "Payment Providers", "Financial Services"];
const ATTRIBUTES = [
  { icon: <Braces className="h-4 w-4" />, label: "API-first" },
  { icon: <Boxes className="h-4 w-4" />, label: "Microservices" },
  { icon: <Zap className="h-4 w-4" />, label: "Event-driven" },
  { icon: <Layers className="h-4 w-4" />, label: "Multi-tenant" },
  { icon: <Plug className="h-4 w-4" />, label: "Extensible integrations" },
];

function Connector() {
  return (
    <div className="relative mx-auto h-10 w-px border-l-2 border-dashed border-[#CBD5E1]" aria-hidden="true">
      <span className="drop-dot absolute -left-[4.5px] h-2 w-2 rounded-full bg-[#2563EB]" />
    </div>
  );
}

export default function ArchitectureDiagram({ showAttributes = true }) {
  return (
    <div data-testid="architecture-diagram" className="mx-auto max-w-2xl">
      <Reveal className="rounded-2xl border border-[#E2E8F0] bg-white px-6 py-4 text-center shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
        <p className="text-sm font-semibold text-[#1D305B]">APIs</p>
        <p className="mt-0.5 text-xs text-[#64748B]">Client, partner and channel applications</p>
      </Reveal>
      <Connector />
      <Reveal delay={80} className="rounded-2xl border border-[#2563EB]/30 bg-[#2563EB]/[0.04] px-6 py-4 text-center">
        <p className="text-sm font-semibold text-[#1D305B]">API Gateway</p>
        <p className="mt-0.5 text-xs text-[#64748B]">Authentication · throttling · routing · observability</p>
      </Reveal>
      <Connector />
      <Reveal delay={160} className="rounded-2xl border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.16em] text-[#64748B]">Microservices</p>
        <div className="mt-4 flex flex-wrap justify-center gap-2.5">
          {SERVICES.map((s) => (
            <span
              key={s}
              className="rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] px-4 py-2 text-sm font-medium text-[#1D305B]"
            >
              {s}
            </span>
          ))}
        </div>
      </Reveal>
      <Connector />
      <Reveal delay={240} className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        {EXTERNALS.map((e) => (
          <div
            key={e}
            className="rounded-xl border border-[#E2E8F0] bg-[#1D305B] px-4 py-3.5 text-center text-[13px] font-semibold text-white"
          >
            {e}
          </div>
        ))}
      </Reveal>

      {showAttributes && (
        <Reveal delay={320} className="mt-8 flex flex-wrap justify-center gap-2.5">
          {ATTRIBUTES.map((a, i) => (
            <span
              key={a.label}
              data-testid={`architecture-attribute-${i}`}
              className="inline-flex items-center gap-2 rounded-full border border-[#E2E8F0] bg-white px-4 py-2 text-[13px] font-medium text-[#334155]"
            >
              <span className="text-[#2563EB]">{a.icon}</span>
              {a.label}
            </span>
          ))}
        </Reveal>
      )}
    </div>
  );
}
